import fetch from 'auth/FetchInterceptor'
import fetchLogin from 'auth/LoginInterceptor'
import { API_BASE_URL } from 'configs/AppConfig'
import {
	createCognitoAuthClient,
	isCognitoPasswordMode as isCommonCognitoPasswordMode,
} from './CognitoAuthClient'

const AuthService = {}

const AUTH_MODE = process.env.REACT_APP_AUTH_MODE || 'cognito-password'

const cognitoAuthClient = createCognitoAuthClient({
	apiBaseUrl: API_BASE_URL,
	fetcher: fetchLogin,
})

AuthService.getAuthMode = function () {
	return AUTH_MODE
}

AuthService.isCognitoPasswordMode = function () {
	return isCommonCognitoPasswordMode(AUTH_MODE)
}

AuthService.login = function (data) {
	if (AuthService.isCognitoPasswordMode()) {
		return cognitoAuthClient.login(data)
	}

	return fetchLogin({
		url: '/api/auth/local?populate=*',
		method: 'post',
		data: data
	})
}

AuthService.getRole = function (data) {
	//SOSTITUITO PER OTTENERE ANCHE I NOMI
	/*return fetch({
		url: '/api/users/me?populate=*',
		method: 'get',
	})*/

	/* NUOVA GET PER PRENDERMI SIA I BINDING PER GLI STORE CHE I BINDING PER LE COMPANY LATO CONTABILITA */
	return fetch({
		url: '/api/users/me?pagination[limit]=-1&status=published&populate[role]=true&populate[binding_roles][populate][store]=true&populate[binding_role_user_companies][populate][company][populate][image]=true',
		method: 'get',
	})
}

AuthService.getSessionContext = function () {
	return fetch({
		url: '/api/session-context/me',
		method: 'get',
	})
}

AuthService.getFotoProfilo = function (data) {
	//SOSTITUITO PER OTTENERE ANCHE I NOMI
	return fetch({
		url: '/api/users/me?status=published&populate[foto_profilo]=true&populate[binding_roles][populate][store]=true',
		method: 'get',
	})
}

AuthService.completeNewPassword = function (data) {
	return cognitoAuthClient.completeNewPassword(data)
}

AuthService.resetPassword = function (data) {
	if (AuthService.isCognitoPasswordMode()) {
		return cognitoAuthClient.confirmForgotPassword({
			...data,
			identifier: data.identifier || data.email,
		})
	}

	return fetch({
		url: '/api/auth/reset-password',
		method: 'post',
		data: data
	})
}

AuthService.forgotPassword = function (data) {
	if (AuthService.isCognitoPasswordMode()) {
		return cognitoAuthClient.forgotPassword({
			...data,
			identifier: data.identifier || data.email,
		})
	}

	return fetch({
		url: '/api/auth/forgot-password',
		method: 'post',
		data: data
	})
}

AuthService.check = function () {

	return fetchLogin({
		url: '/api/users/count',
		method: 'get'
	})
}

AuthService.register = function (data) {
	return fetch({
		url: '/auth/register',
		method: 'post',
		data: data
	})
}

AuthService.logout = function () {
	return fetch({
		url: '/auth/logout',
		method: 'post'
	})
}

AuthService.loginInOAuth = function () {
	return fetch({
		url: '/auth/loginInOAuth',
		method: 'post'
	})
}

export default AuthService;
